import {Divider, FormControl, FormHelperText, InputLabel, MenuItem, Select, Tooltip} from "@material-ui/core";
import {useState} from "react";
import * as PropTypes from "prop-types";
import Typography from "@material-ui/core/Typography";
import DoneIcon from '@material-ui/icons/Done';
import {Help} from "@material-ui/icons";
import Box from "@material-ui/core/Box";
import {defaultSelectStyles} from "./DefaultSelectStyles";


const DefaultSelect = (props) => {
    const classes = defaultSelectStyles();
    const [open, setOpen] = useState(false);

    return (
        <FormControl hidden={props.hidden}
                     fullWidth={props.fullWidth}
                     className={props.formControlStyle}>
            <InputLabel style={{color: "#ccc"}}>{props.label}</InputLabel>
            <Select open={open}
                    onClose={() => setOpen(false)}
                    onOpen={() => setOpen(true)}
                    value={props.value}
                    disabled={props.disabled}
                    name={props.name}
                    onChange={props.handleOnChange}
                    MenuProps={{classes: {paper: classes.dropdownStyle}}}>
                {props.hasEmptyItem ? <MenuItem value={""}/> : null}
                {props.menuItems ? props.menuItems.map((item, index) => {
                    if (item.text === "divider") {
                        return (<Divider key={"divider-" + index}/>)
                    } else {
                        return (
                            <MenuItem key={"menu-item-" + item.value} value={item.value}>
                                <Box className={classes.text}>
                                    <Typography className={`${item.bold ? classes.boldText : null}`}
                                                display={"inline"}>
                                        {item.text}
                                    </Typography>
                                    {item.tooltip ?
                                        <>
                                            <Tooltip title={item.tooltip}
                                                     className={"ml-12"}
                                                     placement={"bottom-start"}
                                                     arrow>
                                                <Help fontSize={"small"} color={"primary"}/>
                                            </Tooltip>
                                        </> : null
                                    }
                                </Box>
                                <DoneIcon className={classes.doneIcon}/>
                            </MenuItem>
                        )
                    }
                }) : null}
            </Select>
            {props.helperText ? <FormHelperText>{props.helperText}</FormHelperText> : ""}
        </FormControl>
    )
}

DefaultSelect.propTypes = {
    label: PropTypes.string,
    value: PropTypes.any,
    formControlStyle: PropTypes.string,
    handleOnChange: PropTypes.func,
    menuItems: PropTypes.array,
    hidden: PropTypes.bool,
    disabled: PropTypes.bool,
    hasEmptyItem: PropTypes.bool,
    fullWidth: PropTypes.bool,
    name: PropTypes.string,
    helperText: PropTypes.string
}

DefaultSelect.defaultProps = {
    hidden: false,
    disabled: false,
    hasEmptyItem: true,
    fullWidth: false
}

export default DefaultSelect;
